import { render, staticRenderFns } from "./t-resource.vue?vue&type=template&id=26e56eac&scoped=true&"
import script from "./t-resource.vue?vue&type=script&lang=js&"
export * from "./t-resource.vue?vue&type=script&lang=js&"
import style0 from "./t-resource.vue?vue&type=style&index=0&id=26e56eac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26e56eac",
  null
  
)

export default component.exports